const apiAccess = {
  apiAccess: {
    apiAccessTitle: 'API-Zugriff',
    apiAppContent:
      'Mit der API des Enlighten Systems können Software-Entwickler externe Anwendungen zum Auslesen der Systemproduktionsdaten schreiben. Diese Anwendungen können Sie zur Eingabe einer Benutzer-ID auffordern, um API-Anfragen in Ihrem Auftrag zu stellen. Ihre Benutzer-ID ist %{user_id}.',
    showApp: 'Anwendungen mit API-Zugriff anzeigen',
    isGrantedApp: 'Sie haben den API-Zugriff für keine Anwendung freigegeben.',
    apiSystemContent:
      'Eine externe Anwendung kann nur Daten für Systeme abrufen, die den API-Zugriff zulassen. Dies wird vom Systembetreiber überprüft. Wenn ein von Ihnen einsehbares System hier nicht aufgeführt ist, liegt das daran, dass der Betreiber sich entschieden hat, keinen API-Zugriff zu gewähren.',
    showSystem: 'Systeme anzeigen, die den API-Zugriff gewähren',
    isGrantedSystem: 'Sie haben keinem System den API-Zugriff erlaubt.',
    revokeAccess: 'Zugriff widerrufen'
  }
};

export default apiAccess;
